import LoaderBar from '../../components/loader-bar/LoaderBar';
import ProjectCardList from '../project-card-list/ProjectCardList';
import { ProjectCardStyles } from '../../utils/cms-utils';

export const TvaProjectCards = ({ projectIds, loading }) => {
    if (loading) {
        return <LoaderBar />;
    }

    if (!projectIds) {
        return null;
    }

    return <ProjectCardList projectIds={projectIds} type={ProjectCardStyles.STANDARD_SMALL} />;
};
